var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4534 37.711C50.3625 41.7821 48.0218 45.4084 44.761 48.0789C41.5003 50.7494 37.4838 52.3295 33.2775 52.5966C29.0713 52.8637 24.8872 51.8043 21.3148 49.5678C17.7424 47.3312 14.9618 44.0301 13.3648 40.1297C11.7677 36.2292 11.4346 31.926 12.4125 27.8263C13.3905 23.7266 15.63 20.037 18.8157 17.2774C22.0014 14.5178 25.9727 12.8272 30.17 12.4439C34.3673 12.0607 38.579 13.004 42.2118 15.141",
    stroke: "#08A2AA",
    strokeWidth: 2.22025,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2376 25.7377C58.6529 31.0196 58.3753 36.6126 56.4439 41.7284C54.5125 46.8443 51.0246 51.2253 46.4717 54.2541C41.9188 57.2828 36.5303 58.8068 31.0655 58.6112C25.6007 58.4156 20.335 56.5104 16.0102 53.1639C11.6855 49.8174 8.51972 45.1983 6.95896 39.9575C5.3982 34.7166 5.52111 29.1181 7.31037 23.9508C9.09964 18.7835 12.4651 14.3079 16.9325 11.1544C21.4 8.00089 26.7442 6.32857 32.2124 6.37302",
    stroke: "#08A2AA",
    strokeWidth: 2.22025,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5694 29.1705C20.2665 26.5686 21.7625 24.251 23.8465 22.5443C25.9305 20.8375 28.4974 19.8277 31.1857 19.657C33.874 19.4862 36.5481 20.1633 38.8312 21.5927C41.1144 23.0221 42.8915 25.1319 43.9122 27.6247C44.9329 30.1175 45.1458 32.8677 44.5208 35.4879C43.8958 38.1081 42.4644 40.4662 40.4284 42.2299C38.3924 43.9936 35.8543 45.074 33.1718 45.319C30.4893 45.5639 27.7975 44.961 25.4757 43.5953",
    stroke: "#08A2AA",
    strokeWidth: 2.22025,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderIco);
export default __webpack_public_path__ + "static/media/loader-ico.17bb38f0c4c75503bdb5705953d84164.svg";
export { ForwardRef as ReactComponent };